/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Høyre mot venstre",
		"timeZoneID": "Tidssone",
		"skin": "Stil",
		"metricsFileImportTask": "Ny import fra Filer",
		"displayMode": "Standardvisning",
		"credentialRenewed": "Legitimasjonen din er fornyet med din gjeldende bruker-ID og passord.",
		"productLocale": "Produktspråk",
		"toggleDisabled": "av",
		"credentialChange": "Forny",
		"log_level_Debug": "Feilsøk",
		"confirmNewPassword": "Bekreft nytt passord",
		"unsavedViewMsg2": "Endringene vil gå tapt hvis du ikke lagrer dem først.",
		"supportPortalErrorMessage": "Prøv igjen.  Kontakt administratoren hvis problemet vedvarer.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, the IBM logo, ibm.com and Cognos are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide. A current list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml. This Program is licensed under the terms of the license agreement accompanying the Program. This license agreement may be either located in a Program directory folder or library identified as \"License\" or \"Non_IBM_License\" if applicable, or provided as a printed license agreement. Please read the agreement carefully before using the Program. By using the Program you agree to these terms.",
		"groupsAndRoles": "Grupper og roller",
		"metricsMaintenanceTask": "Nytt vedlikehold",
		"email": "E-post",
		"contextual": "Kontekstavhengig",
		"resetHome": "Tilbakestill til standard",
		"ltr": "Venstre mot høyre",
		"credentials": "Legitimasjon",
		"logging_congfig_title": "Logging",
		"changePasswordTitle": "Endre passordet mitt",
		"format": "Rapportformat",
		"showUnread": "Vis uleste",
		"AILearning_active": "AI-læring er på:",
		"docsErrorMessage": "Prøv igjen.  Kontakt administratoren hvis problemet vedvarer.",
		"toggleEnabled": "på",
		"homeSetError": "Det oppstod en feil da standard hjemmeside skulle defineres. Prøv å lukke denne visningen og åpne den igjen.",
		"passwordChange": "Endre passordet",
		"profile": "Profil",
		"pdfRestricted": "PDF (begrenset)",
		"drillThrough": "Gjennomdrillingsdefinisjoner",
		"homeSet": "Hjemmesiden din ble definert",
		"regionalOptions": "Regionale alternativer",
		"myPreferences": "Mine innstillinger",
		"defaultHome": "Standard",
		"version": "Versjon",
		"controller": "Controller",
		"manage": "Administrer",
		"biDirectionalFeaturesEnabled": "Støtte for toveisspråk",
		"newFeaturesErrorTitle": "Linken til Nye funksjoner virket ikke",
		"passwordMatch": "Passordsamsvar",
		"updateProfileAndsettings": "Oppdater profil og innstillinger",
		"dashboardConsole": "Arbeidsområde",
		"legacyAppsSlideoutLabel": "Tilgjengelige gamle applikasjoner",
		"logging_config_description": "Logging brukes til feilsøking. Kontakt administratoren for å få hjelp til innstillingene.",
		"confirmDeletion": "Bekreft sletting",
		"signInButtonText": "Logg på",
		"dataSourceCredentials": "Dataserverlegitimasjon",
		"AILearningConfigurationSlideoutAllyLabel": "Konfigurasjon for AI-læring",
		"loadingSettings": "Laster inn innstillinger",
		"spreadsheetMLRestricted": "Excel (begrenset)",
		"manageAILearning": "AI-læring",
		"xlsxDataRestricted": "Excel-data (begrenset)",
		"advanced": "Avanserte alternativer",
		"ok": "OK",
		"changeEmail": "Endre",
		"showHints": "Vis tips",
		"general": "Generelt",
		"xlsxData": "Excel-data",
		"newPassword": "Nytt passord",
		"hideAll": "Skjul alle",
		"confirmPassword": "Bekreft passord",
		"AILearning_config_description": "Forbedre produktets anbefalinger ved å tillate Cognos Analytics å lære om din bruk.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Linken til Support Portal virket ikke",
		"log_level_Warn": "Advarsel",
		"contentSettings": "Innholdsinnstillinger",
		"setHomeButton": "Definer",
		"myCapabilities": "Mine funksjoner",
		"homePage": "Hjemmeside",
		"helpErrorMessage": "Prøv igjen.  Kontakt administratoren hvis problemet vedvarer.",
		"loadingProfile": "Laster inn profil",
		"portal": "Portal",
		"metricsPackage": "Ny pakke",
		"myCredentials": "Min legitimasjon",
		"credentialCreate": "Opprett",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Kan ikke oppdatere passord",
		"showHiddenObjects": "Vis skjulte oppføringer",
		"csv": "CSV",
		"docsErrorTitle": "Linken til dokumentasjonen virket ikke",
		"log_level_Error": "Feil",
		"wrongPassword": "Kan ikke autentisere",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Informasjon",
		"welcomeBanner": "Velkomstbanner",
		"helpErrorTitle": "Linken til Hjelp virket ikke",
		"contentLocale": "Innholdsspråk",
		"pdf": "PDF",
		"oldPassword": "Gammelt passord",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Tilgjengelighetsfunksjoner",
		"manageLogging": "Logging",
		"loggingConfigurationSlideoutA11yLabel": "Loggingskonfigurasjon",
		"communityErrorTitle": "Linken til Fellesskap virket ikke",
		"companionApps": "Companion-applikasjoner",
		"setHomeLabel": "Definer hjem som (gjeldende visning)",
		"metricsExportTask": "Ny eksport",
		"csvRestricted": "CSV (begrenset)",
		"newFeaturesErrorMessage": "Prøv igjen.  Kontakt administratoren hvis problemet vedvarer.",
		"contributor": "Contributor",
		"showAll": "Vis alle",
		"logging_active": "Logging er på:",
		"html": "HTML",
		"profileAndSettings": "Profil og innstillinger",
		"baseTextDirection": "Basisretning for tekst",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Passord",
		"invalidEmail": "Oppgi en gyldig e-postadresse",
		"credentialCreateSuccess": "Du har opprettet legitimasjonen din",
		"settings": "Innstillinger",
		"restrictedFormatSelected": "Du har ikke mulighet til å kjøre rapporter i dette formatet, men du kan bruke rapporter som er lagret i dette formatet.",
		"usageDataDeletionConfirmation": "Hvis bruksdata blir slettet, tilbakestilles eventuell AI-læring.  Er du sikker på at du vil slette bruksdata?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Vis detaljer",
		"deleteUsageData": "Slett bruksdata:",
		"showPassword": "Vis passord",
		"AILearning_config_title": "AI-læring",
		"myPreferencesSlideoutLabel": "Profil og innstillinger",
		"passWordChangeSuccess": "Du har endret passordet",
		"logging_level": "Loggingsnivå:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Prøv igjen.  Kontakt administratoren hvis problemet vedvarer.",
		"cancel": "Avbryt",
		"shareSetError": "Denne handlingen kan ikke utføres før du lukker denne visningen og åpner den igjen.",
		"passwordNotMatch": "Passordene samsvarer ikke",
		"xml": "XML",
		"xmlRestricted": "XML (begrenset)",
		"openMenu": "Åpne meny",
		"closeMenu": 'Lukk meny'
});